import { render, staticRenderFns } from "./MasterLayout.vue?vue&type=template&id=4fc0df4b&scoped=true&%40click=toggleMobileNav&"
import script from "./MasterLayout.vue?vue&type=script&lang=js&"
export * from "./MasterLayout.vue?vue&type=script&lang=js&"
import style0 from "./MasterLayout.vue?vue&type=style&index=0&id=4fc0df4b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc0df4b",
  null
  
)

export default component.exports